import React from "react";

import Topbar from "../components/topbar";
import { useMediaQuery, useTheme, Box, Paper } from "@mui/material";
import GroupDefinition from "./assumptions/group-definition";

const Assumptions: React.FC = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    React.useEffect(() => {
        document.title = "FineAnts | Assumptions";
    }, []);

    return (
        <div style={{ width: '100%' }}>
            <Topbar
                title="Group Definition"
                isMobile={isMobile}
            />
            <Box sx={{ width: "100%" }}>
                <Box sx={{ padding: isMobile ? 0.5 : 1 }}>
                    <Paper
                        sx={{
                            background: 'var(--color-page-background)',
                            width: '100%',
                            padding: 2,
                            boxSizing: 'border-box',
                            borderRadius: 0,
                        }}
                    >
                        <GroupDefinition />
                    </Paper>
                </Box>
            </Box>
        </div>
    );
};

export default Assumptions;
